import { memo } from "react";
import LiveQuranSkeleton from "./LiveQuranSkeleton";
import type { PreviousClass } from "../types/liveQuran";
// @ts-ignore
// @ts-ignore
import sekhobanner from "../Assets/Images/Banner-third-image.webp";

export interface LiveQuranProps {
  isLoading: boolean;
  checkClass: boolean;
  currentClass: string;
  previousClass: PreviousClass[];
  onPreviousVideoPressed: (url: string) => void;
}

const PreviousClassCard = ({
  item,
  onSelect,
}: {
  item: PreviousClass;
  onSelect: (url: string) => void;
}) => (
  <div className="col-12 col-sm-6 col-md-4 my-3 col-lg-3">
    <div
      className="card h-100 border-0 br-card"
      style={{ cursor: "pointer" }}
      onClick={() => onSelect(item.url)}
    >
      <div className="course-card-img position-relative">
        <img
          src={`https://img.youtube.com/vi/${item.url}/hqdefault.jpg`}
          className="card-img-top"
          style={{ borderRadius: "20px" }}
          alt={item.title}
        />
      </div>
      <div style={{ margin: 8 }}>
        <span style={{ fontWeight: "500", fontSize: 14 }}>{item.title}</span>
        <br />
        <span style={{ fontWeight: "500", fontSize: 14, marginTop: 10 }}>
          Class {item.id}{" "}
          <span style={{ color: "#969696", fontWeight: "normal" }}>
            {item.description}
          </span>
        </span>
      </div>
    </div>
  </div>
);

const LiveQuran = ({
  isLoading,
  checkClass,
  currentClass,
  previousClass,
  onPreviousVideoPressed,
}: LiveQuranProps) => {
  if (isLoading) {
    return <LiveQuranSkeleton />;
  }

  return (
    <div>
      <div>
        {checkClass ? (
          <iframe
            height="600px"
            width="100%"
            src={`https://www.youtube.com/embed/${currentClass}?autoplay=0&&controls=1&rel=1`}
            title="Live Quran class"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            className="youtubePlayerContainer"
          />
        ) : (
          <div className="seekho--banner">
            <div className="container-xxl">
              <div className="row">
                <div className="col-md-6 col-12">
                  <div className="abs--text">
                    <div className="banner--heading">
                      Participate in{" "}
                      <span>
                        Live
                        <br /> Quran.
                      </span>{" "}
                    </div>
                    <div className="banner--description">
                      Learn Live Quran with tajweed, In Islam tajweed is a set
                      of rules to help readers recite the Quran in the same way
                      that Prophet Muhammad (PBUH) learned from Jibreel.
                      Reciting without Tajweed could change the meaning of
                      words.
                    </div>
                  </div>
                </div>
                <div className="col-md-6 col-12">
                  <div className="livequranbanner">
                    <img src={sekhobanner} alt="banner" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      <div>
        {previousClass.length > 0 ? (
          <div className="container-xxl">
            <div className="row">
              <span
                style={{
                  fontSize: 22,
                  fontWeight: "600",
                  textAlign: "center",
                  marginTop: 10,
                }}
              >
                More Videos
              </span>
              {previousClass.map((item) => (
                <PreviousClassCard
                  key={item.id}
                  item={item}
                  onSelect={onPreviousVideoPressed}
                />
              ))}
            </div>
          </div>
        ) : (
          <div>no previous videos</div>
        )}
      </div>
    </div>
  );
};

export default memo(LiveQuran);
